<section class="row p-0 m-0 mt-4 mb-5">
  <div class="container">
    <div
      class="col-12 d-flex flex-column align-items-center"
      style="padding-top: 85px"
    >
      <h3 class="my-h3 p-0 m-0">Quem Somos</h3>
    </div>
    <div class="row p-0 m-0 mt-4">
      <div class="col-md-4">
        <img
          src="https://meuvidraceiro.com.br/assets/images/quem-somos-vidraceiro.jpg"
          width="100%"
          height="300"
          alt=""
        />
      </div>
      <div class="col-md-8">
        <p class="my-p small-p">
          O MeuVidraceiro é uma plataforma online que conecta clientes que
          buscam serviços de vidraçaria pela internet com profissionais do vidro
          de todo país. Uma ideia ousada e inovadora, que promete aumentar as
          oportunidades de orçamentos dos vidraceiros e apresentar maior
          variedade de profissionais aos clientes de maneira simples e objetiva.
        </p>
        <p class="my-p small-p mt-2">
          A plataforma torna a divulgação de serviços de instalação de vidro
          muito mais prática e ágil, sendo uma grande oportunidade de gerar mais
          negócios e aumentar o faturamento de vidraçarias e vidraceiros
          autônomos.
        </p>
        <p class="my-p small-p mt-2">
          O cliente que busca serviços de vidraçaria e terá a oportunidade de
          receber diferentes orçamentos de profissionais próximos a sua região
          de forma rápida e totalmente gratuita.
        </p>
        <p class="my-p small-p mt-2">
          Divulgar e encontrar serviços de vidraçaria no ambiente digital é uma
          das grandes dificuldades percebidas pela Vidro Impresso, mídia focada
          em comunicação para o mercado do vidro há mais de 10 anos, que decidiu
          investir na criação da plataforma MeuVidraceiro.
        </p>
      </div>
      <div class="col-12 mt-4">
        <p class="my-p small-p">
          A revista Vidro Impresso traz conteúdo exclusivo para o setor,
          informações sobre normas técnicas, dicas de produtos e fornecedores.
          Comunicar está no DNA da Vidro Impresso, que também possui uma agência
          especializada em marketing digital para o setor vidreiro.
        </p>
      </div>
    </div>
  </div>
</section>
